var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.generateClass},[_c('p',{attrs:{"data-cy":_vm.config.cyData}},[_vm._v(" "+_vm._s(_vm.config.placeholder)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }